<template>
  <div class="policy-detail">
    <img class="img" src="@/assets/images/policy_match.png" />
    <div class="header">
      <div class="avatar-box flex" :class="{'vip-content':isVip}">
        <div class="flex-avatar">
          <div class="avatar-img-b" @click="clickCodeFirm">
            <img class="avatar-img" :src="userInfo.avatar" alt="" v-if="userInfo.avatar"/>
            <img class="avatar-img" src="@/assets/images/avatar.jpg" alt=""  v-else/>
          </div>
          <!--<img class="vip-img" src="@/assets/images/setup/icon_vip_1@2x.png" alt="" v-if="isVip"/>-->
          <!--<img class="vip-img" src="@/assets/images/setup/icon_vip_2@2x.png" alt="" v-else/>-->
        </div>
        <div class="flex-item flex user-info">
          <div class="flex-item">
            <div class="title_1" v-if="userInfo.company && userInfo.company.name">{{userInfo.company.name}}</div>
            <div class="name">
              {{userInfo.nickname}}
              <!--<img class="vip-flag" src="@/assets/images/setup/vip@2x.png" alt="" v-if="isVip"/>-->
            </div>
            <!--<div class="vip_no_flag_box" v-if="!isVip"  @click="toVip">-->
              <!--<span>获取VIP，享受六大权益</span>  -->
            <!--</div>-->
          </div>
        </div>
      </div>
      <div class="set-ad">
        <coupon-ad :type="'setup'"></coupon-ad>
        <div class="grid-box match-detail">
          <van-grid class="" :border="false" :column-num="5">
            <van-grid-item  v-for="menu in menus" :key="menu.path" @click="toDetail(menu)">
              <img class="nav-img" :src="menu.icon" />
              <div class="grid-name">{{menu.name}}</div>
            </van-grid-item>
          </van-grid>
        </div>
        </div>
    </div>
    <div class="homeBar">

     <!-- <div class="homeLi" @click="clickUrl('/center')"> -->
     <!-- <div class="homeLi">
       <div class="flexqq">
          <img src="@/assets/images/setup/icon_item_1@2x.png" class="homeIcon">
          <div class="homeText"> 个人设置</div>
        </div>
        <img src="img/rr.png" class="rr">
      </div> -->
      <!-- <div class="homeLi" @click="clickUrl('/vip')"> -->
      <!-- <div class="homeLi" @click="clickUrlVip"> -->
       <!-- <div class="flexqq">
          <img src="@/assets/images/setup/icon_item_2@2x.png" class="homeIcon">
          <div class="homeText"> VIP 会员</div>
        </div>
        <img src="img/rr.png" class="rr">
      </div> -->
      <div class="homeLi" @click="clickMatch">
       <div class="flexqq">
          <img src="@/assets/images/setup/icon_item_11@2x.png" class="homeIcon">
          <div class="homeText"> 完善信息</div>
        </div>
        <img src="img/rr.png" class="rr">
      </div>
      <div class="homeLi" @click="checkCertification">
       <div class="flexqq">
          <img src="@/assets/images/setup/icon_item_9@2x.png" class="homeIcon">
          <div class="homeText"> 关联企业
            <span v-if="userInfo.company && userInfo.company.audit_status == '1'">(审核中)</span>
          </div>
        </div>
        <img src="img/rr.png" class="rr">
      </div>
      <div class="homeLi" @click="clickResearchUrl" v-show="showZqc">
       <div class="flexqq">
          <img src="@/assets/images/setup/icon_item_8@2x.png" class="homeIcon">
          <div class="homeText"> 调研填报</div>
        </div>
        <img src="img/rr.png" class="rr">
      </div>
      <div class="homeLi" @click="clickUrl('/order')">
       <div class="flexqq">
          <img src="@/assets/images/setup/icon_item_3@2x.png" class="homeIcon">
          <div class="homeText"> 我的订单</div>
        </div>
        <img src="img/rr.png" class="rr">
      </div>
      <div class="homeLi" @click="clickUrl('/matters')">
       <div class="flexqq">
          <img src="@/assets/images/setup/icon_item_4@2x.png" class="homeIcon">
          <div class="homeText"> 我的事项</div>
        </div>
        <img src="img/rr.png" class="rr">
      </div>
      <!--
      <div class="homeLi" @click="clickUrl('/coupon')">
       <div class="flexqq">
          <img src="@/assets/images/setup/icon_item_10@2x.png" class="homeIcon">
          <div class="homeText"> 我的卡券</div>
        </div>
        <img src="img/rr.png" class="rr">
      </div>
      -->
      <div class="homeLi" @click="clickUrl('/collect')">
       <div class="flexqq">
          <img src="@/assets/images/setup/icon_item_5@2x.png" class="homeIcon">
          <div class="homeText"> 我的收藏</div>
        </div>
        <img src="img/rr.png" class="rr">
      </div>
      <!-- <div class="homeLi" @click="clickUrl('/subscribe')">
       <div class="flexqq">
          <img src="@/assets/images/setup/icon_item_6@2x.png" class="homeIcon">
          <div class="homeText"> 我的订阅</div>
        </div>
        <img src="img/rr.png" class="rr">
      </div> -->
      <div class="homeLi" @click="goWxScanCode()">
       <div class="flexqq">
          <img src="@/assets/images/setup/icon_item_7@2x.png" class="homeIcon">
          <div class="homeText"> 立即扫码</div>
        </div>
        <img src="img/rr.png" class="rr">
      </div>
    </div>

    <div class="version">
      版本号：v2.0.1.220615_beta
    </div>
</div>
</template>

<script>
import { getUserInfo,getUserId,setQuestion } from '@/utils/storage'
import { queryUserById,getUserInfoZqcli,getWxUserInfo } from '@/api/home'
import { clickUrl, checkResearch, goCodeFirm } from '@/utils'
import { WeixinShare } from '@/utils/wx'
import icon_group_1 from '@/assets/images/setup/icon_group_1@2x.png'
import icon_group_2 from '@/assets/images/setup/icon_group_2@2x.png'
import icon_group_3 from '@/assets/images/setup/icon_group_3@2x.png'
import icon_group_4 from '@/assets/images/setup/icon_group_4@2x.png'
import icon_group_5 from '@/assets/images/setup/icon_group_5@2x.png'
import icon_group_6 from '@/assets/images/setup/icon_group_6@2x.png'
import CouponAd from '../../components/CouponAd.vue'
import { ZqcUrl,ZqcUrlCompanyone } from '@/config'

export default {
  data() {
    return {
      isVip: false,
      showAbout: false,
      showPreview: false,
      question: null,
      contactInfo: '',
      menus: [
        { name: '服务机构', icon: icon_group_1, path: '/mall' },
        { name: '立项查询', icon: icon_group_5, path: '/project_query/index' },
        { name: '信息中心', icon: icon_group_2, path: '/policy_query/index',query:{type:'declare'} },
        // { name: 'VIP服务', icon: icon_group_6, path: '/vip' },
        // { name: '政策文件', icon: icon_group_3, path: '/policy_query/index',query:{type:'policy'} },
        // { name: '通知公告', icon: icon_group_4, path: '/policy_query/index',query:{type:'notify'} },
      ],
      userId:'',
      userInfo:{},
      couponInfo:{},
      userInfoZqc: '',
      showZqc: false
    }
  },
  components: { CouponAd },
  watch:{
  },
  mounted(){
    localStorage.removeItem('urlZct')
    this.getUserInfoZqc()
    this.getCompany()
  },
  methods: {
    toVip() {
      if (goCodeFirm(this.userInfo)) {
        return false
      }
      clickUrl('/vip')
    },
    async getCompany(){
      try {
      let res = await queryUserById()
      this.userInfo = res.result || {}
      this.userId = res.result.id
      let e_time = res.result.expiration_time ? res.result.expiration_time.replace(/-/g,'/'):null
      let expirationTime = new Date(e_time).getTime()
      let time = new Date().getTime()
      this.isVip = time < expirationTime ? true : false
      // if(!sessionStorage.getItem('authenticationFlag')){
      //   this.checkAuthenticate()
      //   }
        goCodeFirm(this.userInfo)
      } catch (res) {
        if (res.status == '2') {
          goCodeFirm(this.userInfo)
        }
      }
    },
    toDetail(item) {
      if (goCodeFirm(this.userInfo)) {
        return false
      }
      let query= {
        ...item.query
      }
      clickUrl(item.path,query)
    },
    clickUrl(url) {
      if (goCodeFirm(this.userInfo)) {
        return false
      }
      console.log(url)
      // this.$router.push({path: url})
      clickUrl(url)
    },
    clickUrlVip() {
      var u = navigator.userAgent
      if (u.indexOf('miniProgram') !== -1) {
        window.wx.miniProgram.navigateTo({ url: '../pay/pay' })
      }
    },
    //调用微信扫码
    async goWxScanCode(){
      const that = this;
      let userAgent = that.checkUserAgent()
      if(!userAgent){
        return false
      }
      window.wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['qrCode'], // 可以指定扫二维码还是一维码，默认二者都有
        success: function(res) {
          // TODO 执行自己的逻辑
          let result = res.resultStr
          console.log('扫描的结果:',result)
          window.location.href = result
        },
        error: function(response) {
          that.$toast(response)
        }
      });
    },
    checkUserAgent(){
      var that = this
      // 对浏览器的UserAgent进行正则匹配，不含有微信独有标识的则为其他浏览器
      var useragent = navigator.userAgent;
      if (useragent.match(/MicroMessenger/i) != 'MicroMessenger') {
          // 这里警告框会阻塞当前页面继续加载
          that.$dialog.alert({message:'请在微信浏览器中访问本页面'})
          return false
      }
      return true
    },
    checkAuthenticate(type) {
      if (goCodeFirm(this.userInfo)) {
        return false
      }

      if(!type && this.userInfo.authentication_flag){
        return false
      }

      if(!this.userInfo.authentication_flag){
        this.couponInfo = {
          title: '温馨提示',
          content: '认证企业信息即可领取1000元',
          btnConfirmTxt: '去领取'
        }
      }else{
        this.couponInfo = {
          title: '温馨提示',
          content: '您已认证，是否重新认证企业信息?',
          btnConfirmTxt: '确认',
          btnCancleTxt: '取消'
        }
      }

      var that = this
      this.$dialog.confirm({
        title: this.couponInfo.title,
        message: this.couponInfo.content,
        confirmButtonText:this.couponInfo.btnConfirmTxt
      }).then(() => {
        that.goCoupon()
      }).catch(() => {
        that.closePopup()
      });
    },
    goCoupon() {
      if (goCodeFirm(this.userInfo)) {
        return false
      }

      sessionStorage.setItem('authenticationFlag',1)
      if(this.userInfo.authentication_flag){
        // clickUrl('/coupon/company_certificate')
        clickUrl('/purchase', {source:'certificateAgain'})
      }else{
       clickUrl('/coupon/use_detail')
      }
    },
    checkCertification() {
      if (goCodeFirm(this.userInfo)) {
        return false
      }

      if(!this.userInfo.certification_flag){
        clickUrl('/purchase', { source: 'certificateAgain' })
        return false
       }

       if (this.userInfo.company && this.userInfo.company.audit_status == '1') {
        this.$toast('该企业关联正在审核中')
        return false
      }

      this.couponInfo = {
        title: '温馨提示',
        content: '您已关联，是否重新关联企业信息?',
        btnConfirmTxt: '确认',
        btnCancleTxt: '取消'
      }
      var that = this
      this.$dialog.confirm({
        title: this.couponInfo.title,
        message: this.couponInfo.content,
        confirmButtonText:this.couponInfo.btnConfirmTxt
      }).then(() => {
        clickUrl('/purchase', { source: 'certificateAgain' })
      }).catch(() => {
        
      });
    },
    closePopup(){
      sessionStorage.setItem('authenticationFlag',1)
    },
    clickResearchUrl() {
      if (goCodeFirm(this.userInfo)) {
        return false
      }
      var that = this
      window.location.href =  window.location.origin + ZqcUrl

      // var that = this
      // if (that.userInfoZqc.status == 0) {
      //   that.$dialog.alert({
      //     title: '温馨提示',
      //     message: '你还未认证企业，是否前往认证'
      //   }).then(() => {
      //     sessionStorage.setItem('urlZct', location.href)
      //     window.location.href = ZqcUrlCompanyone
      //   }).catch(() => {
      //   })
      //   return;
      // }
      // sessionStorage.setItem('urlZct', location.href)
      // checkResearch(that.userInfoZqc.questions)
    },
    async getUserInfoZqc(){
      var that = this
      try{
        let res = await getUserInfoZqcli()
        that.userInfoZqc = res.result
        if (!that.userInfoZqc.org_id || that.userInfoZqc.org_id == null) {
          this.showZqc = false
          return
        }
        this.showZqc = true
      }catch{
        this.showZqc = false
      }


      // try{
      //   let res = await getUserInfoZqcli()
      //   that.userInfoZqc = res.result
      //   // if (that.userInfoZqc.status == 0) {
      //   //   sessionStorage.setItem('urlZct', location.href)
      //   //   window.location.href = ZqcUrlCompanyone
      //   //   return;
      //   // }
      // }catch(res){
      //   if(res.status == 6){
      //     sessionStorage.setItem('urlZct', location.href)
      //     window.location.href = ZqcUrlCompanyone
      //   }
      // }
    },
    clickMatch() {
      if (goCodeFirm(this.userInfo)) {
        return false
      }
      let name = this.userInfo.company && this.userInfo.company.name ? this.userInfo.company.name : ""
      if (!this.userInfo.certification_flag || !name) {
        clickUrl('/purchase', { source: 'addCompanyInfo' })
        return false
      }
      let searchStr = {
        name: name
      }
      clickUrl('/search/1', { search: JSON.stringify(searchStr), type: 2 })
    },
    clickCodeFirm() {
      goCodeFirm(this.userInfo)
    }
  }
}
</script>
<style lang="scss" scoped>
.policy-detail{
  padding: 13px 10px;
}
.policy-detail .img{
  height: auto;
  top: -50px;
}
.policy-detail .header{
  margin-bottom: 20px;
}
.user-info{
  align-items: center;
  margin-left: 10px;
}
.avatar-box{
  margin: .3rem;
  padding: 0.53rem 0.35rem 0;
  .flex-avatar{
    width: 73px;
    height: 73px;
    border: 2px solid #FFFFFF;
    border-radius: 50%;
    display: inline-block;
    position: relative;
    .avatar-img-b{
            width: 73px;
          height: 73px;
          overflow: hidden; 
          border-radius: 50%;
        }
    .avatar-img{
      width: 100%;
      height: 100%;
      background-size: contain;
    }
    .vip-img{
      width: 51px;
      height: 27px;
      background-size: 100% 100%;
      position: absolute;
      top: -25px;
      left: 11px;
      z-index:5;
    }

  }
  .title_1{
    font-size: 18px;
    font-family: 'PingFang SC-Semibold, PingFang SC';
    font-weight: 600;
    line-height: 21px;
    color: #fff;
    margin-bottom: 3px;
  }
  .name{
    font-size: 14px;
    color: #fff;
    line-height: 16px;
  }
}
.match-detail{
  border-radius: 20px;
  // box-shadow: 0px 4px 12px 1px rgba(15, 94, 149, 0.3);
  margin-top: -0.6rem;

}
.grid-box{
  // padding: .5rem;
  padding: 0 10px;
  font-size: 12px;
  text-align: center;
  justify-content: center;
  .nav-img{
    width: 100%;
    background-size: contain;
    margin-bottom: 5px;
  }
  .grid-name{
    white-space: nowrap;
  }
}
.myHome {
  overflow: hidden
}

.HomeHead {
  display: flex;
  align-items: center;
  height: 180px;
  /*background: url("img/bggs.png") no-repeat;*/
  background-size: 100% 100%;
  width: 100%;
  margin-bottom: 15px;
  padding: 0 15px
}

.myname {
  color: #333;
  font-size: 17px;
  margin-left: 8px
}

.HomeBanner {
  overflow: hidden;
  margin: 10px 0 15px;
  box-shadow: 0px 1px 9px rgba(0, 0, 0, .1);
  border-radius: 12px;
  width: 100%;
  height: 0;
  padding-bottom: 45%
}

.homeimg {
  width: 100%;
}

.homeBar {
  width: 100%;
  height: auto;
  background: #fff;
  overflow: hidden;
  margin-bottom: 15px;
  border-radius: 20px;
  // box-shadow: 0px 4px 12px 1px rgba(15, 94, 149, 0.3);
}

.kimg1 {
  width: 100%;
}

.kimg2 {
  width: 100%;
}

.Barpd {
  margin: 20px 15px
}

.homeTitle {
  margin: 15px 15px;
  font-size: 16px;
  font-weight: bold
}

.homeLi {
  display: flex;
  padding: 15px 15px 15px 15px;
  border-bottom: 1px solid #eee;
  margin: 0 10px;
  justify-content: space-between;
  align-items: center
}

.homeLi:nth-last-child(1) {
  border-bottom: 0px;
}

.homeIcon {
  display: block;
  margin-right: 10px;
  height: 20px;
  width: 20px;
  background-size: contain;
}

.homeText {
  font-size: 15px;
  color: #333;
}

.homeText span {
  color: #42b983
}

.rr {
  display: block;
  height: 14px;
  float: right
}

.flexqq {
  display: flex;
  align-items: center;
  flex: 1;
}

.homecont {
  padding: 10px 0
}

.contxt {
  display: flex;
  align-items: center;
  padding: 10px 20px;
}

.contxt .icc {
  width: 14px;
  height: 14px;
  /*background: url("img/g6.png") no-repeat;*/
  background-size: 100% 100%;
  display: block;
  margin-right: 5px;
  flex-shrink: 0
}

.contxt h1 {
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.yss {
  color: #e6422d;
  flex-shrink: 0
}

.companyname {
  font-size: 16px;
  color: #fff
}

.rinfo {
  margin: 0 15px
}

.ynames {
  font-size: 15px;
  color: #f5f5f5;
  padding-top: 10px
}

.version{
  font-size: 10px;
  font-family: 'PingFang SC-Medium, PingFang SC';
  font-weight: 500;
  color: #B5B5B5;
  line-height: 12px;
  width: 100%;
  text-align: center;
  margin-top: 13px;
}

.vip_no_flag_box{
  width: 140px;
  height: 20px;
  background: url('../../assets/images/setup/bg_vip@2x.png') no-repeat center center;
  background-size: contain;
  color: #fff;
  font-size: 12px;
  padding: 3px 20px 3px 5px;
}
.vip-content{
  .flex-avatar{
    border: 2px solid #ebc38c;
  }
  .title_1{
    color: #D2AF7D;
  }
  .vip-flag{
    width: 41px;
    background-size: contain;
    vertical-align: middle;
  }
}

::v-deep .van-grid{
  justify-content: space-evenly;
}

.set-ad{
  position: relative;
  z-index: 5;
}
.coupon-box{
  margin: 0 10px !important;
  position: relative;
  z-index: -1;
}
</style>
